module.exports = __webpack_public_path__ + "img/lg_ring_g_skip_null_null@3x.af84b6e4.png";